import type { PlainEnvironment } from "@/queries/environment-queries";
import { getGitReferenceFromInitializer } from "@/utils/environment";
import { useMemo } from "react";

export type GitReferenceType = "branch" | "tag";

export type GitReference = {
    type: GitReferenceType;
    value: string;
};

export function getGitReference(environment?: PlainEnvironment): GitReference | undefined {
    // Use the branch if available from git status
    if (environment?.status?.content?.git?.branch) {
        return {
            type: "branch",
            value: environment.status.content.git.branch,
        };
    }

    // If there are failure messages, then default to "no branch"
    if ((environment?.status?.failureMessage?.length ?? 0) > 0) {
        return {
            type: "branch",
            value: "no branch",
        };
    }

    // Fall back to get the reference from the initializer
    return getGitReferenceFromInitializer(environment?.spec?.content?.initializer);
}

export function useGitReference(environment?: PlainEnvironment): GitReference | undefined {
    const gitReference = useMemo(() => getGitReference(environment), [environment]);
    return gitReference;
}

// Backward compatibility - keep the original useBranch hook
export function useBranch(environment?: PlainEnvironment): string | undefined {
    const gitReference = useGitReference(environment);
    return gitReference?.value;
}
